import React from "react";
import { useQuery } from "react-query";
import { _api_get_solde_by_leave_id } from "../../api/leave";

const useQueryGetSoldeByLeaveId = ({ leave_id, enable }) => {
    const data = useQuery(
        ["get_solde_by_leave_id", leave_id],
        () => {
            return _api_get_solde_by_leave_id(leave_id);
        },
        {
            enabled: enable === true && !!leave_id,
            refetchOnWindowFocus: false,
        }
    );

    return data;
};

export default useQueryGetSoldeByLeaveId;
